import React from 'react';
import { LighterObject } from './LighterObject';
export function Hero() {
  return <section id="top" className="border-b border-hairline bg-white" data-id="element-37" data-mp="ek68ouphyeaw">
      <div className="mx-auto max-w-shell px-4 py-20 sm:px-8 sm:py-28" data-id="element-38" data-mp="ehtjpxlbn3oc">
        <div className="flex flex-col items-center text-center" style={{
        backgroundColor: "#EEE3E3",
        backgroundImage: "none",
        gap: "0px",
        width: "1369px"
      }} data-id="element-39" data-mp="9lbhp5hdljfp">
          <p className="inline-flex items-center gap-2 rounded-md border border-hairline bg-[#fbfbfc] px-3 py-1.5 font-mono text-xs text-muted" data-id="element-40" data-mp="12a0mbehn46w7">
            <span className="h-1.5 w-1.5 rounded-sm bg-[#22c55e]" aria-hidden="true" data-id="element-41" data-mp="xaxfboi3nqll" />
            prod server <span className="text-hairline" data-id="element-42" data-mp="s9q7xqjvctfg">/</span>
            <span className="text-ink" data-id="element-43" data-mp="ncq13df73mna">running</span>
          </p>

          <h1 className="mt-8 max-w-3xl text-[clamp(2.75rem,7vw,5.25rem)] font-semibold leading-[0.95] tracking-tightest text-void" style={{
          textAlign: "right",
          backgroundImage: "url(\"https://cdn.magicpatterns.com/uploads/3Q8GTvzh9G4RDDoN1KXgy9/vps.png\")",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          paddingTop: "34px",
          paddingBottom: "34px",
          paddingRight: "98px",
          marginTop: "42px",
          marginBottom: "42px"
        }} data-id="element-44" data-mp="neaz5d0pxnpw">
            The JavaScript Tooling Company
          </h1>

          <p className="mt-6 max-w-xl text-base text-ink sm:text-lg" style={{
          marginTop: "0px"
        }} data-id="element-45" data-mp="3e8ehhbn6zq5j">
            Making JavaScript developers more productive than ever before.
          </p>

          <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row" data-id="element-46" data-mp="359t19n570n7x">
            <a href="#projects" className="rounded-md bg-ink px-5 py-3 text-sm font-medium text-white transition-colors duration-150 void-ease hover:bg-void" data-id="element-47" data-mp="2qkdd8ex1qvvx">
              Explore the toolchain
            </a>
            <a href="#github" className="rounded-md border border-hairline px-5 py-3 text-sm font-medium text-ink transition-colors duration-150 void-ease hover:bg-black/[0.04]" data-id="element-48" data-mp="2hix03zeukfo0">
              Read the source
            </a>
          </div>

          <div className="mt-20 flex justify-center" data-id="element-49" data-mp="s3cmudv0pps5">
            <LighterObject data-id="element-50" data-mp="nb1kz5gpvtwy" />
          </div>
        </div>
      </div>
    </section>;
}